import {
  GET_USER_ACTIVITIES,
  GET_USER_ACTIVITIES_SUCCESS,
  GET_USER_ACTIVITIES_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  userActivities: {},
};

const getUserActivityReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_ACTIVITIES:
      return { ...state, loading: true };
    case GET_USER_ACTIVITIES_SUCCESS:
      return {
        ...state,
        userActivities: action?.payload,
        loading: false,
      };
    case GET_USER_ACTIVITIES_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getUserActivityReducer;
